module.exports = __webpack_public_path__ + "components/flag/static/square/hm-a4edd562a9e3345383b6085a5254d644.svg";